import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import c from '../../../constant';
import { riskLevels } from '../utils';

function RiskMatrixTable() {
	const bgHeader = '#CFEEC3';
	const bgBody = '#E6F8DD';

	const cell = {
		border: '1px solid black',
		fontSize: '14px',
		backgroundColor: bgBody,
		padding: '0 0 0 3px',
	};

	const headCell = {
		...cell,
		backgroundColor: bgHeader,
		fontWeight: 'extrabold',
		textAlign: 'center',
	};

	return (
		<Box w="100%">
			<Box border="0.5px solid black" overflow="hidden" borderRadius={c.borderRadius}>
				<Table variant="unstyled">
					<Thead>
						<Tr>
							<Th {...headCell}>Risk level</Th>
							<Th {...headCell}>Risk Code</Th>
							<Th {...headCell}>Score</Th>
							<Th {...headCell}>Status</Th>
						</Tr>
					</Thead>
					<Tbody pl={5}>
						{riskLevels?.map((r) => (
							<Tr key={r.level}>
								<Td {...cell}>{r.level}</Td>
								<Td {...cell} bg={r.boxBg} color={r.textColor} textAlign="center" fontWeight="bold">
									{r.code}
								</Td>
								<Td {...cell}>{r.score}</Td>
								<Td {...cell}>{r.status}</Td>
							</Tr>
						))}
					</Tbody>
				</Table>
			</Box>

			<Text mt={1} fontStyle="italic" fontSize="sm" textAlign="center">
				*In Active and In Rehabilitation – No taken action
			</Text>
		</Box>
	);
}

export default RiskMatrixTable;
